export enum ReportTypeEnum {
    PDF = 1,
    XLSX = 2
}